import { getPricingOfAccountRCSCampaign, editPricingOfAccountRCSCampaign } from "../types/account_campaign_pricing_rcs_types";




export const getPricingOfAccountRCSCampaignRequest = (payload, cb) => ({
  type: getPricingOfAccountRCSCampaign.REQUEST,
  payload,
  cb,
});
export const getPricingOfAccountRCSCampaignSuccess = (payload) => ({
  type: getPricingOfAccountRCSCampaign.SUCCESS,
  payload,
});
export const getPricingOfAccountRCSCampaignError = (payload) => ({
  type: getPricingOfAccountRCSCampaign.ERROR,
  payload,
});

export const editPricingOfAccountRCSCampaignRequest = (payload, cb) => ({
  type: editPricingOfAccountRCSCampaign.REQUEST,
  payload,
  cb,
});
export const editPricingOfAccountRCSCampaignSuccess = (payload) => ({
  type: editPricingOfAccountRCSCampaign.SUCCESS,
  payload,
});
export const editPricingOfAccountRCSCampaignError = (payload) => ({
  type: editPricingOfAccountRCSCampaign.ERROR,
});
